import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AsyncValidatorFn, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Helper } from '../../utilities/classes/helper.class';
import { BehaviorSubject, finalize, Observable, of, OperatorFunction, startWith, Subscription } from 'rxjs';

@Component({
  selector: 'app-acc-simple-input-text-form',
  templateUrl: './acc-simple-input-text-form.component.html',
  styleUrls: ['./acc-simple-input-text-form.component.scss']
})
export class AccSimpleInputTextFormComponent {

  public readonly Helper = Helper;
  public readonly fg = this._newFg();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AccSimpleInputTextFormInterface,
    public ref: MatDialogRef<AccSimpleInputTextFormComponent>,
  ) {
    this.data = {
      ...data,
      formClass: data.formClass || 'min-w-[500px]'
    }
  }

  public onSubmit() {
    if (Helper.getInvalidControls(this.fg).length) return;
    if (this.fg) this.data?.onSubmit(this.fg.value, this.ref, this.data);
  }

  private _newFg() {
    let controls = {};
    this.data.controls.forEach(c => {

      if (c.inputType == "empty") return;

      const rValidators = c.required ? [Helper.reactiveForms.validatos.required] : [];
      const cValidators = c.validators ?? [];
      const asyncValidators = c.asyncValidators ?? [];

      const control = Helper.reactiveForms.control<unknown>(c.initialValue, [...cValidators, ...rValidators], [...asyncValidators]);
      if (c.disabled) control.disable();

      if (c.onValueChanges) {
        const subs: Subscription = control.valueChanges.pipe(
          finalize(() => subs.unsubscribe()),
        ).subscribe(newVal => {
          if (!this.fg) return null;
          return c.onValueChanges ? c.onValueChanges(newVal, this.fg) : null;
        });
      }

      controls = { ...controls, [`${c.name}`]: control };
    });

    return new FormGroup(controls);
  }


}

export interface AccSimpleInputTextFormInterface {
  isRequesting$?: BehaviorSubject<boolean> | null,
  title?: string | null,
  onSubmit: (formData: Record<string, any>, ref?: MatDialogRef<any> | null, matData?: AccSimpleInputTextFormInterface | null) => void,
  onSubmitText?: string | null,
  controls: AccSimpleInputTextFormControlInterface[],
  formClass?: string | null,
  showCancelButton?: boolean | null,
}

export interface AccSimpleInputTextFormControlInterface {
  name: string,
  label?: string | null,
  alias?: string | null,
  initialValue?: any | null,
  required?: boolean | null,
  colClassName: string,
  toolTip?: string | null,
  selectOptions$?: BehaviorSubject<{ value: any, key: string }[]>,
  inputType?: "number" | "text" | "checkbox" | "date" | "date-range" | "select" | "search" | "hidden" | 'empty' | null,
  validators?: ValidatorFn[] | null,
  asyncValidators?: AsyncValidatorFn[] | null,
  onValueChanges?: (newValue: any, formGroup: FormGroup) => void,
  disabled?: boolean | null,
  minDate?: Date | null,
  maxDate?: Date | null,
  minNumber?: number | null,
  maxNumber?: number | null,
  // | "datetime" | "datetime-range" | "email" | "color" | "file"
}

